













































































































































































import Vue from 'vue'
import { AxiosResponse } from 'axios'
import { getHostAndDomain } from '../../util/helper'
import ContactSupport from '@/pmd/components/common/ContactSupport.vue'
import MultipleUsersLogin from '../components/MultipleUsersLogin.vue'
import { OauthService } from '@/services'
import LoginOTPScreen from './LoginOTPScreen.vue'
import config from '@/config'
import { handleSuccessfulLogin, handleLoginError } from '../utils/LoginHelper'
import LoginUIAlert from '../components/LoginUIAlert.vue'
import XCloseIcon from './reporting/notification/XCloseIcon.vue'
import CompanyService from '../../services/CompanyService'
import allowedAgenciesForSSO from '../utils/SSOAgencyList'

const MoonLoader = () => import('@/pmd/components/MoonLoader.vue')

export default Vue.extend({
  name: 'LoginWithEmail',
  metaInfo: {
    title: 'Login',
  },
  components: {
    MoonLoader,
    ContactSupport,
    MultipleUsersLogin,
    LoginOTPScreen,
    LoginUIAlert,
    XCloseIcon
  },
  data() {
    return {
      response: '',
      email: '',
      password: '',
      loading: false,
      logoURL: '',
      privacyURL: '',
      termsConditionsURL: '',
      domainCompanyId: null,
      multipleUsersFound: null,
      resetPasswordMsg: false,
      googleAuth: undefined,
      emailMask: '',
      phoneMask: '',
      totpEnabled: false,
      isOtpScreen: false,
      selectedCompanyId: '',
      isLoginWithGoogleAllowed: false,
      loader: false,
      isLoginWithSSOAllowed: false,
      isCannyLogin: false,
      cannyRedirectUrl: '',
      cannyCompanyId: '',
      isWhiteLabelLoginWithGoogleAllowed: false,
    }
  },
  computed : {
    inactivityLogoutMsg() {
      return this.$store.getters['auth/isInactivityLogout']
    }
  },
  created() {
    this.loader = true
  },
  async mounted() {
    await this.fetchBrandData()
    this.initializeLoginPage()
  },
  methods: {
    async fetchBrandData() {
      try {
        const hostDomainInfo = getHostAndDomain()
        const response = await CompanyService.getBranding(hostDomainInfo.domain)
        if(response.info){
          this.setBrandData(response.info)
        } else {
          this.setDefaultBrandData()
        }
      } catch (err) {
        this.setDefaultBrandData()
      } finally {
        this.finalizeBrandDataLoading()
      }
    },
    setBrandData(data) {
      this.logoURL = data.logoURL
      if (getHostAndDomain()?.domain?.includes('leadconnectorhq')) {
        this.logoURL = 'leadconnectorhq'
      }
      this.logoURL && $('link[rel="icon"]').attr('href', this.logoURL)
      this.privacyURL = data.privacyURL || ''
      this.termsConditionsURL = data.termsConditionsURL || data.privacyURL || ''
      this.domainCompanyId = data.companyId
      this.applyCustomCSS(data.customCSS)
      this.applyTheme(data.theme)
      this.isLoginWithSSOAllowed = allowedAgenciesForSSO.includes(this.domainCompanyId)
      this.isWhiteLabelLoginWithGoogleAllowed = data.whitelabelLoginConfig?.isGoogleLoginEnabled
    },
    setDefaultBrandData() {
      this.isLoginWithSSOAllowed = getHostAndDomain()?.domain?.includes('localhost')
      this.logoURL = getHostAndDomain()?.domain?.includes('leadconnectorhq') ? 'leadconnectorhq' : 'default'
      this.privacyURL = 'https://www.gohighlevel.com/privacy'
      this.termsConditionsURL = 'https://www.gohighlevel.com/terms-of-service'
    },
    finalizeBrandDataLoading() {
      document.getElementById('app')?.classList.remove('loading')
      this.$store.commit('setAgencyLoaderState', false)
      this.loader = false
    },
    applyCustomCSS(customCSS) {
      if (customCSS) {
        let style = document.createElement('style')
        style.type = 'text/css'
        style.media = 'screen'
        style.appendChild(document.createTextNode(customCSS))
        document.head.appendChild(style)
      }
    },
    applyTheme(theme) {
      if (theme) {
        document.body.dataset.theme = theme
      }
    },
    initializeLoginPage() {
      this.isOtpScreen = false
      this.isCannyLogin = this.$router.currentRoute?.query?.app === 'canny'
      if (this.isCannyLogin) {
        this.cannyRedirectUrl = this.$router.currentRoute?.query?.redirect
        this.cannyCompanyId = this.$router.currentRoute?.query?.companyID
      }

      if (['dev', 'staging'].includes(config.mode) || getHostAndDomain()?.domain?.includes('gohighlevel')) {
        this.checkAndInitGoogleLogin()
      }

      this.isLoginWithSSOAllowed = allowedAgenciesForSSO.includes(this.domainCompanyId)
      if (this.$router.currentRoute?.query?.email) {
        this.email = this.$router.currentRoute?.query?.email
      }
      if (this.$router.currentRoute?.query?.reset_password) {
        this.resetPasswordMsg = this.$router.currentRoute?.query?.reset_password
      }

       // Handle whitelabel google login
      let googleAuth = this.$router.currentRoute?.query?.googleAuth
      if (googleAuth) {
        // remove googleAuth and type from the query
        this.$router.replace('/')
        const decodedGoogleAuth = atob(googleAuth)
        googleAuth = JSON.parse(decodedGoogleAuth)
        this.submit(false, googleAuth)
      }
    },
    forceCloseInactivityAlert() {
      this.$store.commit('auth/updateInactivityLogout', false)
    },
    handleWhiteLabelGoogleLogin() {
      let url = `https://login.leadconnectorhq.com/google?origin=${window.location.origin}`
      if(config.mode != 'production'){
        url = `https://login-staging.leadconnectorhq.com/google?origin=${window.location.origin}`
      }
      window.open(url, '_self')
    },
    checkAndInitGoogleLogin(interval = 1) {
      if (window.google && google.accounts) {
        this.googleLoginInit()
      } else {
        setTimeout(() => this.checkAndInitGoogleLogin(interval + 1), interval * 500)
      }
    },
    googleLoginInit() {
      google.accounts.id.initialize({
        client_id: config.googleAuthId,
        callback: params => this.submit(false, params),
      })
      google.accounts.id.renderButton(
        document.getElementById('g_id_signin'),
        { theme: 'outline', size: 'large', width: 370 } // customization attributes
      )
      google.accounts.id.prompt() // also display the One Tap dialog
      this.isLoginWithGoogleAllowed = true
    },
    async submit(selectedAgencyMultipleUsers?: string, googleAuth: any) {
      try {
        if (selectedAgencyMultipleUsers && this.googleAuth) {
          googleAuth = this.googleAuth
        }
        this.googleAuth = googleAuth

        if (!googleAuth) {
          await this.$validator.validateAll()
          if (this.errors.any()) {
            return Promise.resolve(true)
          }
        }

        this.loading = true
        this.response = ''

        const params = {
          ...getHostAndDomain(),
          email: this.email.trim(),
          password: this.password.trim(),
          deviceId: await this.$store.dispatch('getDeviceId'),
          deviceType: 'web',
          deviceName: navigator.userAgent,
          token: googleAuth?.credential,
        } as { [key: string]: any }

        this.selectedCompanyId = undefined
        if (this.domainCompanyId && this.domainCompanyId !== 'YuTUZlUtrwBtvmgByZDW') {
          params.companyId = this.domainCompanyId
          this.selectedCompanyId = this.domainCompanyId
        } else if (selectedAgencyMultipleUsers) {
          params.companyId = selectedAgencyMultipleUsers
          this.selectedCompanyId = selectedAgencyMultipleUsers
        }

        if (googleAuth) {
          // remove these properties because auth with throw err. Refer to GoogleLoginDto in MP repo
          delete params.domain
          delete params.subdomain
          delete params.email
          delete params.password
          params.isWLGoogleLogin = this.isWhiteLabelLoginWithGoogleAllowed
        }

        const response = await OauthService.loginWithEmail(params, googleAuth ? 'google' : 'email')

        if (response.multipleUsers) {
          this.multipleUsersFound = response.multipleUsers
          return
        }

        if (!googleAuth && !response.token) {
          this.handleOtpScreen(response)
          return
        }

        await handleSuccessfulLogin(response, this.$store, this.$router)

      } catch (error) {
        const { errorMessage } = handleLoginError(error, this.email)
        this.response = errorMessage
      } finally {
        this.loading = false
      }
    },
    handleOtpScreen(response) {
      this.emailMask = response.email
      this.phoneMask = response.phone
      this.totpEnabled = response.totpEnabled
      this.isOtpScreen = true
    },
    async selectAgencyMultipleUser(selectedAgencyMultipleUsers) {
      this.multipleUsersFound = null
      await this.submit(selectedAgencyMultipleUsers)
    },
    shouldShowForgotPassword() {
      return !(this.$router?.currentRoute?.query?.src === 'marketplace')
    },
    handleLoginWithSSO() {
      // get the url from the query and add to the url
      const url = this.$route.query.url
      if (url) {
        this.$router.push({
          name: 'login_sso',
          query: { url: decodeURIComponent(url) }
        })
      } else {
        this.$router.push({ name: 'login_sso' })
      }
    },
  },
})
